import React, { useState, useEffect, useContext } from 'react'
import { MenuItem, FormControl, InputLabel, Select } from '@mui/material'
import './homePage.css'
import RooftopMenu from '../rooftopsComponent/menu/menu'
import SapDirectNavigation from '../../pages/sap-direct/Navigation'
import Header from '../header/header'
import { NavLink, useLocation } from 'react-router-dom'
import Cube from '../../assets/images/cube.png'
import { UserContext } from '../../context/userContext'
import { GetUserProfileAndPermissions } from '@carrier-sce-sharedpackages/reactauthwrapper'
import { appConfig } from '../../environments/environments'

function HomePage() {
    const [UserName] = useState('')
    const { pathname } = useLocation()
    const displayRooftopMenu = pathname.includes('rooftop')
    const { state, setState } = useContext(UserContext)

    useEffect(() => {
        let username = (value) => {
            setState((prev) => ({
                ...prev,
                UserName: `${value.firstName} ${value.lastName}`,
            }))
        }
        GetUserProfileAndPermissions(appConfig.apiUrl, appConfig.uiUrl, username)
    }, [setState])
    return (
        <div className='header'>
            <Header UserName={state.UserName || UserName} />
            <div className='menu'>
                <label>
                    <img alt='' src={Cube} className='cube' />
                </label>
                <FormControl variant='filled' className='formcontrol'>
                    <InputLabel htmlFor='filled_age_native_simple'>Product line</InputLabel>
                    <Select id='product_line_select' value={pathname.split('/')[1] || ''}>
                        <MenuItem id='product_line_option_rooftops' component={NavLink} to='/rooftops' value='rooftops'>
                            Rooftops{' '}
                        </MenuItem>
                        <MenuItem id='product_line_option_chillers' component={NavLink} to='/chillers' value='chillers'>
                            Chillers{' '}
                        </MenuItem>
                        <MenuItem id='product_line_option_controls' component={NavLink} to='/controls' value='controls'>
                            Controls{' '}
                        </MenuItem>
                        <MenuItem
                            component={NavLink}
                            to={`/${encodeURIComponent('Coolant Distribution Unit')}`}
                            value='Coolant Distribution Unit'>
                            Coolant Distribution Unit{' '}
                        </MenuItem>
                        <MenuItem component={NavLink} to='/control-depracted' value='control-depracted'>
                            Control (supervision) - depracted{' '}
                        </MenuItem>
                        <MenuItem id='product_line_option_sap_direct' component={NavLink} to='/sap-direct' value='sap-direct'>
                            SAP Direct Pricing{' '}
                        </MenuItem>
                    </Select>
                </FormControl>
                {displayRooftopMenu && <RooftopMenu />}
                {pathname.startsWith('/sap-direct') && <SapDirectNavigation />}
            </div>
        </div>
    )
}

export default HomePage
